module.exports = __webpack_public_path__ + "img/1.4a00e803.jpg";